import { SharedState } from '$utils/sharedState.svelte';
import type { User } from '$types/user';
import { UserType } from '$types/userType';

class StateMe extends SharedState<User> {
  onboarding = () => {
    const currentUserType = this.current?.type ?? UserType.UNKNOWN;

    const onboardingUserTypes = [
      UserType.SIGNUP,
      UserType.MIGRATING,
      UserType.UNKNOWN,
      UserType.INVITE,
    ];

    return onboardingUserTypes.includes(currentUserType);
  };
}

export const stateMe = new StateMe(null);
